export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./taxes.vue?vue&type=template&id=2562678d"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/taxes.vue?vue&type=template&id=2562678d
// module id = enJ+
// module chunks = 0